import { Plan } from '@/types/schema.generated'

type PlanVersion = 'unknown' | '2022_1' | '2023_1'

const V2022_1PLANS: Plan[] = [
  Plan.V2022_1Pr,
  Plan.V2022_1Entry,
  Plan.V2022_1Pro,
  Plan.V2022_1Enterprise,
]

const V2023_1PLANS: Plan[] = [
  Plan.V2023_1SkillForce,
  Plan.V2023_1Expert,
  Plan.V2023_1Master,
  Plan.V2023_1Enterprise,
]

export function getPlanVersion(plan: Plan): PlanVersion {
  if (V2022_1PLANS.includes(plan)) {
    return '2022_1'
  }
  if (V2023_1PLANS.includes(plan)) {
    return '2023_1'
  }
  return 'unknown'
}
